import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lmc-env/environment';
import { Observable } from 'rxjs';

export interface AppsConversionEmployee {
  employeeID: number;
  full_name: string;
  position: string;
}

export interface AppsConversionConfig {
  employeeIds: number[];
  employees: AppsConversionEmployee[];
}

@Injectable({
  providedIn: 'root',
})
export class AppsConversionConfigService {
  private readonly uri: string = `${environment.DO_URL}/v2/config/apps-conversion`;

  constructor(private readonly http: HttpClient) {}

  getConfig(): Observable<{ success: boolean; data: AppsConversionConfig }> {
    return this.http.get<{ success: boolean; data: AppsConversionConfig }>(this.uri);
  }

  updateConfig(employeeIds: number[]): Observable<{ success: boolean; message: string }> {
    return this.http.put<{ success: boolean; message: string }>(this.uri, { employeeIds });
  }
}
